import { render, staticRenderFns } from "./BarChatFeedback.vue?vue&type=template&id=3de9e734&scoped=true"
import script from "./BarChatFeedback.vue?vue&type=script&lang=ts"
export * from "./BarChatFeedback.vue?vue&type=script&lang=ts"
import style0 from "./BarChatFeedback.vue?vue&type=style&index=0&id=3de9e734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de9e734",
  null
  
)

export default component.exports